import styled from 'styled-components';
import { LinkButton } from '../Button';
import { PrependedIcon, ChildrenWrapper } from '../Button/styles';

export const RefreshButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledRefreshButton = styled(LinkButton).attrs({
  prependIcon: 'fas fa-redo-alt',
})`
  &:not(.disabled),
  &:not(.disabled):hover,
  &:not(.disabled):focus,
  &:not(.disabled):active {
    color: #fff;
    background: #6c727f;
    border-radius: 4px;
    padding: 0 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 22px;
  }

  ${ChildrenWrapper}, ${PrependedIcon} {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 1px;
  }

  ${PrependedIcon} {
    margin-right: 4px;
    font-size: 12px;
    width: 12px;
    height: 12px;
    display: inline-block;
  }
`;

export const RefreshButtonHelperText = styled.div`
  font-size: 14px;
  color: #444;
  margin-right: 14px;
`;
